import { getCurrentTimestamp, detectDeviceType, getDevice, UserOrigin } from '@/utils/analytics';
export default {
  auth: {
    email: '',
    name: '',
    token: false,
    hasPremium: false,
    isPromoAccepted :false
  },
  subscription: {
    list: [],
  },
  publisher: {
    id: null,
    settings: {},
  },
  analytics: {
    env: process.env.VUE_APP_SHOW_ON_ENV || 'stage',
    app: 'accounts',
    countryCode: localStorage.getItem('cc') || 'US',
    timestamp: getCurrentTimestamp(),
    origin: UserOrigin.ORGANIC,
    device: {
      platform: getDevice(), // android or dynamic like detect OS
      deviceType: detectDeviceType(),
    }
  }
};